import { InstagramLogo, TiktokLogo, ArrowUp } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-black px-6 md:px-12 lg:px-20 pt-20 pb-10"
    >
      {/* Giant brand wordmark */}
      <div className="mb-6 overflow-hidden">
        <h2 className="font-display font-black uppercase tracking-tighter leading-[0.85] text-[14vw] lg:text-[11vw] text-white/95 select-none">
          Sweat with{" "}
          <span className="font-brush font-normal normal-case text-[#FF1B91] inline-block transform -rotate-2">Slay</span>
        </h2>
        <p className="mt-4 font-serif-italic text-2xl md:text-3xl lg:text-4xl text-white/70">
          &ldquo;Obsessed with watching people win.&rdquo;
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 border-t border-white/10 pt-12 mt-12">
        <div className="md:col-span-3">
          <p className="text-white/60 max-w-xs leading-relaxed">
            Obsessed with watching people win. Strength-first coaching for busy humans, delivered through the Everfit app. Built by Slay.
          </p>
        </div>

        <div className="md:col-span-2">
          <div className="text-[10px] uppercase tracking-[0.3em] text-white/40 mb-4 font-semibold">Site</div>
          <ul className="space-y-3 text-sm">
            <li><a href="#about" data-testid="footer-link-about" className="text-white/80 hover:text-[#FF1B91] transition-colors">About</a></li>
            <li><a href="#programs" data-testid="footer-link-programs" className="text-white/80 hover:text-[#FF1B91] transition-colors">Programs</a></li>
            <li><a href="#everfit" data-testid="footer-link-everfit" className="text-white/80 hover:text-[#FF1B91] transition-colors">Everfit</a></li>
            <li><a href="#contact" data-testid="footer-link-contact" className="text-white/80 hover:text-[#FF1B91] transition-colors">Contact</a></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="text-[10px] uppercase tracking-[0.3em] text-white/40 mb-4 font-semibold">More</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/book" data-testid="footer-link-book" className="text-white/80 hover:text-[#FF1B91] transition-colors">Book a call</Link></li>
            <li><Link to="/legacy" data-testid="footer-link-sacrifice" className="text-white/80 hover:text-[#FF1B91] transition-colors">Legacy Challenge · Year 1</Link></li>
            <li><Link to="/legacy" data-testid="footer-link-news" className="text-white/80 hover:text-[#FF1B91] transition-colors">In the news</Link></li>
            <li><Link to="/testimonial" data-testid="footer-link-testimonial" className="text-white/80 hover:text-[#FF1B91] transition-colors">Share a testimonial</Link></li>
            <li><Link to="/card" data-testid="footer-link-card" className="text-white/80 hover:text-[#FF1B91] transition-colors">Digital card</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="text-[10px] uppercase tracking-[0.3em] text-white/40 mb-4 font-semibold">Follow</div>
          <ul className="space-y-3 text-sm">
            <li>
              <a href="https://instagram.com/sweatwithslay" target="_blank" rel="noreferrer noopener" data-testid="footer-link-instagram" className="text-white/80 hover:text-[#FF1B91] transition-colors flex items-center gap-2">
                <InstagramLogo size={16} weight="bold" /> @sweatwithslay
              </a>
            </li>
            <li>
              <a href="https://instagram.com/alannajohnson" target="_blank" rel="noreferrer noopener" data-testid="footer-link-instagram-personal" className="text-white/80 hover:text-[#FF1B91] transition-colors flex items-center gap-2">
                <InstagramLogo size={16} weight="bold" /> @alannajohnson
              </a>
            </li>
            <li>
              <a href="https://invite.everfit.io/Q9TTSYVZYA" target="_blank" rel="noreferrer noopener" data-testid="footer-link-everfit-app" className="text-white/80 hover:text-[#FF1B91] transition-colors flex items-center gap-2">
                <TiktokLogo size={16} weight="bold" /> Everfit invite
              </a>
            </li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="text-[10px] uppercase tracking-[0.3em] text-white/40 mb-4 font-semibold">Get started</div>
          <p className="text-white/60 text-sm mb-4 leading-relaxed">
            Tell me your goals and I&apos;ll match you with the right tier of support. Takes about 15 minutes.
          </p>
          <a
            href="/intake"
            target="_blank"
            rel="noreferrer noopener"
            data-testid="footer-intake-cta"
            className="inline-flex items-center gap-3 bg-[#FF1B91] hover:bg-[#FF3FA3] text-white px-6 py-3.5 text-[11px] font-bold uppercase tracking-[0.2em] btn-brutal btn-brutal-pink"
          >
            Start your intake →
          </a>
        </div>
      </div>

      <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[11px] uppercase tracking-[0.25em] text-white/40">
        <div>© {new Date().getFullYear()} Sweat With Slay — All rights reserved</div>
        <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
          <Link to="/privacy" data-testid="footer-link-privacy" className="hover:text-[#FF1B91] transition-colors">
            Privacy
          </Link>
          <Link to="/terms" data-testid="footer-link-terms" className="hover:text-[#FF1B91] transition-colors">
            Terms
          </Link>
          <a
            href="#top"
            data-testid="footer-back-to-top"
            className="inline-flex items-center gap-2 hover:text-[#FF1B91] transition-colors"
          >
            Back to top <ArrowUp size={14} weight="bold" />
          </a>
        </div>
      </div>
      <div className="mt-4 text-white/35 normal-case tracking-normal text-[11px] italic">
        In-person training extremely limited — by meeting only.
      </div>
    </footer>
  );
}
